import React, { useState } from 'react';
import PropTypes from 'prop-types';
import formatDateTime from '@afosto/utils/date/formatDateTime';
import { DataGridPreview } from '@afosto/app-components-react/DataGrid';
import Box from '@material-ui/core/Box';
import Property from '@afosto/app-components-react/Property';
import translations from './translations';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { boolean as booleanFormatter } from '@afosto/app-components-react/DataGrid/formatters';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@afosto/app-components-react/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

const CouponCodePreview = ({ isOpen, title, couponCode, onClose, previewMenu }) => {
  const intl = useIntl();
  const [tooltipOpen, setTooltipOpen] = useState(false);

  return (
    <DataGridPreview open={isOpen} title={title} onClose={onClose} menu={previewMenu}>
      <Box pl={2}>
        <Box display="flex" alignItems="flex-end">
          <Box flexGrow={1}>
            <Property
              label={intl.formatMessage(translations.properties.code.label)}
              value={couponCode?.code}
            />
          </Box>
          <ClickAwayListener onClickAway={() => setTooltipOpen(false)}>
            <Tooltip
              PopperProps={{
                disablePortal: true,
              }}
              onClose={() => setTooltipOpen(false)}
              open={tooltipOpen}
              disableFocusListener
              disableHoverListener
              disableTouchListener
              title={intl.formatMessage(translations.feedback.copied)}
            >
              <IconButton
                onClick={() => {
                  navigator.clipboard.writeText(couponCode?.code);
                  setTooltipOpen(true);
                }}
                style={{ marginBottom: -12 }}
              >
                <Icon icon={['fal', 'copy']} />
              </IconButton>
            </Tooltip>
          </ClickAwayListener>
        </Box>
        <Property
          label={intl.formatMessage(translations.properties.expiresAt.label)}
          value={couponCode?.expires_at && formatDateTime(couponCode?.expires_at)}
        />
        <Property
          label={intl.formatMessage(translations.properties.isUnlimited.label)}
          value={booleanFormatter(couponCode?.usage?.is_unlimited)}
        />
        <Property
          label={intl.formatMessage(translations.properties.remaining.label)}
          value={couponCode?.usage?.remaining}
        />
      </Box>
    </DataGridPreview>
  );
};

CouponCodePreview.propTypes = {
  couponCode: PropTypes.object,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  previewMenu: PropTypes.object,
  title: PropTypes.string,
};

CouponCodePreview.defaultProps = {
  couponCode: {},
  isOpen: false,
  onClose: undefined,
  previewMenu: [],
  title: null,
};

export default CouponCodePreview;
